import React from 'react'

function MobileTablet(props) {
  return (
    <svg
      width={80}
      height={80}
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M42.917 63.333h-26.25A6.667 6.667 0 0110 56.667v-40A6.667 6.667 0 0116.667 10h30a6.667 6.667 0 016.666 6.667M53.333 16.667v10"
        stroke="#1F2D27"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.663 52.777a.556.556 0 10.007 1.111.556.556 0 00-.007-1.111M49.583 26.667h13.75A6.667 6.667 0 0170 33.333v30A6.667 6.667 0 0163.333 70h-13.75a6.667 6.667 0 01-6.666-6.667v-30a6.666 6.666 0 016.666-6.666v0zM53.533 62.5h5.834"
        stroke="#1F2D27"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export { MobileTablet }
